//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import SourceCard from 'src/components/base/SourceCard';

export default {
	name: 'OverviewMain',
	components: {
		SourceCard,
	},
	data() {
		return {
			currentTime: moment().format(),
		};
	},
	computed: {
		...mapState('vehicle', ['history']),
		...mapState('datasource', ['type']),
		...mapGetters('vehicle', ['pushedVehicles', 'failedVehicles', 'lastPushAvailable']),
		lastUpload() {
			if (!this.currentTime) return;

			const origin = this.history && this.history.lastDownload
				? moment(this.history.lastDownload)
				: moment();

			let lastUpload = moment(origin)
				.startOf('hour')
				.add(30, 'minutes');

			if (origin.isBefore(lastUpload)) {
				lastUpload.subtract(1, 'hours');
			}

			let prefix = 'Heute';
			if (!moment().isSame(lastUpload, 'day')) {
				prefix = lastUpload.format('DD.MM.YYYY');
			}

			return `${prefix}, ${lastUpload.format('HH:mm')}`;
		},
		nextUpload() {
			if (!this.currentTime) return;

			let nextUpload = moment()
				.startOf('hour')
				.add(30, 'minutes');

			if (moment().isAfter(nextUpload)) {
				nextUpload.add(1, 'hours');
			}

			if (
				this.lastPushAvailable
				&& this.type === 'mobile.de'
			) {
				nextUpload = moment()
					.startOf('day')
					.add(4, 'hours')
					.add(30, 'minutes');

				if (moment().isAfter(nextUpload)) {
					nextUpload.add(1, 'day');
				}
			}

			return moment.duration(
				moment().diff(nextUpload)
			).humanize();
		},
	},
	mounted() {
		this.$options.updateInterval = setInterval(() => {
			this.currentTime = moment().format();
		}, moment.duration(1, 'minute'));
	},
	beforeDestroy() {
		clearInterval(this.$options.updateInterval);
	},
};
